var map = {
	"./Car.svg": 1543,
	"./accept.png": 8291,
	"./announcement.png": 90742,
	"./arrow.svg": 23342,
	"./b2b-car.png": 33240,
	"./backarrow.svg": 24969,
	"./background (2).png": 6392,
	"./background.png": 43495,
	"./bank.svg": 53185,
	"./bike-inspection.png": 13,
	"./bike.svg": 81940,
	"./bikeinsurance.png": 14406,
	"./calender.png": 85333,
	"./cancel.png": 74341,
	"./car-inspection.png": 37694,
	"./check.svg": 96729,
	"./checked.png": 75088,
	"./checksvg.svg": 14853,
	"./complete.gif": 21477,
	"./copy-icon.svg": 48226,
	"./currency_rupee.png": 77336,
	"./dashboard.png": 94639,
	"./dashboardfilter.svg": 56851,
	"./data-not-found.gif": 99151,
	"./delete.svg": 10154,
	"./dot.svg": 50484,
	"./down-arr-blue.png": 97860,
	"./down-arr-dbl.png": 18228,
	"./down-arrow.png": 85979,
	"./down_arw.png": 74266,
	"./download-arw.png": 38788,
	"./download-dark.png": 72158,
	"./drop-down-arrow.png": 67579,
	"./edit-pencil.png": 53101,
	"./edit.svg": 46343,
	"./error (2).gif": 73725,
	"./error.gif": 69230,
	"./errorGif.gif": 17488,
	"./eye.png": 79988,
	"./eyeicon.svg": 28017,
	"./file_upload.svg": 16635,
	"./filtericon.svg": 55174,
	"./fourweeler.png": 55961,
	"./homeicon.svg": 18245,
	"./icons8-funnel-20.png": 96385,
	"./icons8-funnel-21.png": 28120,
	"./icons8-sort-10.png": 29940,
	"./info-extra.png": 17790,
	"./info.svg": 79339,
	"./inspection-bike.png": 70347,
	"./inspection-icon.png": 9931,
	"./journeybg.png": 82230,
	"./kyc.gif": 84607,
	"./logout.svg": 10589,
	"./mailicon.svg": 43005,
	"./minus.svg": 16993,
	"./motor-shield.png": 31668,
	"./multiquotearrow.svg": 42605,
	"./multiquoteloader.gif": 59676,
	"./pageloader.gif": 40064,
	"./paymentFailed.gif": 46629,
	"./paymentPending.gif": 59487,
	"./pdf.svg": 2443,
	"./phoneicon.svg": 45758,
	"./plan-name.png": 58064,
	"./plus.svg": 91363,
	"./printing.png": 47704,
	"./profile.svg": 42198,
	"./profileuser.svg": 75031,
	"./redirection.png": 59833,
	"./refresh.svg": 10456,
	"./remove-25.png": 60313,
	"./right-arrow.svg": 43311,
	"./rightarrow.svg": 1174,
	"./savings-back.png": 27660,
	"./search.svg": 91599,
	"./sort-up.png": 81057,
	"./state-bank-of-india-logo.svg": 41241,
	"./successGif.gif": 18217,
	"./sync.png": 69762,
	"./thankyou.gif": 39945,
	"./twoweeler.png": 7335,
	"./up-arr-blue.png": 44629,
	"./up-arr-dbl.png": 62463,
	"./upload-icon-new.png": 81657,
	"./usericon.svg": 30625,
	"./wealth-right.gif": 63454,
	"./wheel.png": 77062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;